import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExpirationService {


constructor(private http:HttpClient) { }


GetRecord():Observable<Array<FeildActivity_Interface>>{
  return this.http.get(environment.BaseUrl + "Daro/Expiration").pipe(
    map(data=>{
      return data as Array<FeildActivity_Interface>
    })
  )
}

GetActive():Observable<Array<FeildActivity_Interface>>{
  return this.http.get(environment.BaseUrl + "Daro/Expiration/GetActive").pipe(
    map(data=>{
      return data as Array<FeildActivity_Interface>
    })
  )
}

GetActiveAndId(id:number):Observable<Array<FeildActivity_Interface>>{
  return this.http.get(environment.BaseUrl + "Daro/Expiration/GetActiveAndId?id="+id).pipe(
    map(data=>{
      return data as Array<FeildActivity_Interface>
    })
  )
}

GetSingle(id:Number):Observable<FeildActivity_Interface>{
  return this.http.get(environment.BaseUrl + "Daro/Expiration/GetSingle?id="+id).pipe(
    map(data=>{
      return data as FeildActivity_Interface
    })
  )
}

AddExpiration(model: FeildActivity_Interface):Observable<FeildActivity_Interface>{
  const headers = new HttpHeaders().set('content-type', 'application/json');


  var body = {
    id:model.id,
    Title:model.title,
    day:Number(model.code),
    del:false,
    username:'',
    subdate:null
  }


    return this.http.post(environment.BaseUrl + "Daro/Expiration/Add",body,{headers}).pipe(
      map(data=>{
        return data as FeildActivity_Interface
      })
    )

}

EditExpiration(model: FeildActivity_Interface):Observable<FeildActivity_Interface>{
  const headers = new HttpHeaders().set('content-type', 'application/json');


  var body = {
    id:model.id,
    Title:model.title,
    day:Number(model.code),
    del:false,
    username:'',
    subdate:null
  }


    return this.http.post(environment.BaseUrl + "Daro/Expiration/Edit",body,{headers}).pipe(
      map(data=>{
        return data as FeildActivity_Interface
      })
    )

}

DeleteExpiration(id:number):Observable<FeildActivity_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/Expiration/Delete?id="+id).pipe(
      map(data=>{
        return data as FeildActivity_Interface
      })
    )

}
DefaulttExpiration(id:number):Observable<FeildActivity_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/Expiration/Defaultt?id="+id).pipe(
      map(data=>{
        return data as FeildActivity_Interface
      })
    )

}


}
